import React from 'react';
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Divider, IconButton, } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import CloseIcon from '@mui/icons-material/Close';
const useStyles = makeStyles()(theme => ({
    closeButton: {
        position: 'absolute',
        right: theme.spacing(1),
        top: theme.spacing(1),
        color: theme.palette.grey[500],
    },
}));
export default function HelpDialog({ handleClose, }) {
    const { classes } = useStyles();
    return (React.createElement(Dialog, { open: true, maxWidth: "xl", onClose: handleClose },
        React.createElement(DialogTitle, null,
            "Using the search box",
            handleClose ? (React.createElement(IconButton, { className: classes.closeButton, onClick: () => handleClose() },
                React.createElement(CloseIcon, null))) : null),
        React.createElement(Divider, null),
        React.createElement(DialogContent, null,
            React.createElement("h3", null, "Searching"),
            React.createElement("ul", null,
                React.createElement("li", null, "Jump to a feature or reference sequence by typing its name in the location box and pressing Enter."),
                React.createElement("li", null,
                    "Jump to a specific region by typing the region into the location box as: ",
                    React.createElement("code", null, "ref:start..end"),
                    " or ",
                    React.createElement("code", null, "ref:start-end"),
                    ". Commas are allowed in the start and end coordinates. A space-separated list of locstrings can be used to open up multiple chromosomes at a time")),
            React.createElement("h3", null, "Example Searches"),
            React.createElement("ul", null,
                React.createElement("li", null,
                    React.createElement("code", null, "BRCA"),
                    " - searches for the feature named BRCA"),
                React.createElement("li", null,
                    React.createElement("code", null, "chr4"),
                    " - jumps to chromosome 4"),
                React.createElement("li", null,
                    React.createElement("code", null, "chr4:79,500,000..80,000,000"),
                    " - jumps the region on chromosome 4 between 79.5Mb and 80Mb."),
                React.createElement("li", null,
                    React.createElement("code", null, "chr1:1-100 chr2:1-100"),
                    " - create a split view of chr1:1-100 and chr2:1-100"),
                React.createElement("li", null,
                    React.createElement("code", null, "chr1 chr2 chr3"),
                    " - open up multiple chromosomes at once"),
                React.createElement("li", null,
                    React.createElement("code", null, "chr1:1-100[rev] chr2:1-100"),
                    " - open up the first region in the horizontally flipped orientation"),
                React.createElement("li", null,
                    React.createElement("code", null, "chr1 100 200"),
                    " - use whitespace separated refname, start, end"))),
        React.createElement(Divider, null),
        React.createElement(DialogActions, null,
            React.createElement(Button, { onClick: () => handleClose(), color: "primary" }, "Close"))));
}
//# sourceMappingURL=HelpDialog.js.map